import { User } from '@/app/_constant/authType';

import { ListingDetail } from '../_presentation/type';
import createListingObject from './createListingObject';
import { createUserObject } from './createUserObject';

export const trackImpression = (
    listing: ListingDetail,
    profile?: User,
): ListingImpression => {
    const impression: ListingImpression = {
        pageview: trackPageView(profile),
        impression: trackPageImpression(listing, profile),
    };

    return impression;
};

const trackPageView = (profile?: User): Pageview => {
    const user = createUserObject(profile);
    const pageview: Pageview = {
        event: 'pageview',
        featureType: 'PDP',
        userInfo: user,
    };

    return pageview;
};

const trackPageImpression = (
    listing: ListingDetail,
    profile?: User,
): MainTracker => {
    try {
        const user = createUserObject(profile);
        const listingObj = createListingObject(listing);
        const impression: MainTracker = {
            event: 'pageview_ajax_pdp',
            featureType: 'PDP',
            listing: listingObj,
            target: '',
            user: user,
        };
        return impression;
    } catch {
        return {
            event: 'pageview_ajax_pdp',
            featureType: 'PDP',
            listing: {
                id: listing.originId,
            },
            target: '',
        };
    }
};
